import React from 'react';
import { useTranslation } from 'react-i18next';
import './style.scss';
import { Button } from '@uncinc/uncinc-react-kitchen-sink';

interface HamburgerButtonProps {
  isOverlayOpen: boolean;
  setIsOverlayOpen: (state: (prevState: boolean) => boolean) => void;
}

const HamburgerButton = ({ setIsOverlayOpen, isOverlayOpen }: HamburgerButtonProps) => {
  const { t } = useTranslation();

  return (
    <div className="magic-line magic-line--thick">
      <Button
        className="HamburgerButton Button"
        onClick={() => setIsOverlayOpen((state) => !state)}
        primary={false}
      >
        {isOverlayOpen ? t('navigation.menu_hamburger_open') : t('navigation.menu_hamburger')}

        {isOverlayOpen ?
          <i className="icon icon-cross icon-variant-2" /> :
          <i className="icon icon-hamburger-search icon-variant-2" />}
      </Button>
    </div>
  );
};

export default HamburgerButton;
